import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class PreviewIFrame extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            iFrame: '.m-previewIFrame__iFrame',
        };
    }

    getPropsFromDom() {
        return {
            src: this.dom.iFrame.getAttribute('data-src'),
            size: this.dom.iFrame.getAttribute('data-size'),
        };
    }

    updateSize(size) {
        this.setProps({ size });
        this.dom.iFrame.className = `m-previewIFrame__iFrame m-previewIFrame__iFrame--${size}`;
    }

    updateSrc(src) {
        this.updateProps({ src }, true);
        this.allowPointerEvents();
    }

    allowPointerEvents() {
        if (this.dom.iFrame) {
            this.dom.iFrame.style.pointerEvents = 'auto';
        }
    }
}
